/**
 * One dismissible line on Home after the year of tasks exists.
 */

const PREFIX = 'pacarion.tasksReady.';

function tasksReadyStorageKey(clientId) {
  return PREFIX + String(clientId || '');
}

function tasksReadyDismissed(storage, clientId) {
  if (!storage || !clientId) return false;
  try {
    return storage.getItem(tasksReadyStorageKey(clientId)) === '1';
  } catch (error) {
    return false;
  }
}

function dismissTasksReady(storage, clientId) {
  if (!storage || !clientId) return;
  try {
    storage.setItem(tasksReadyStorageKey(clientId), '1');
  } catch (error) {
    // This visit still hides the line.
  }
}

function shouldShowTasksReady({ taskCount, dismissed }) {
  return Number(taskCount) > 0 && !dismissed;
}

module.exports = {
  tasksReadyStorageKey,
  tasksReadyDismissed,
  dismissTasksReady,
  shouldShowTasksReady,
};
